/* eslint-disable no-debugger */
export const localValidate = (formState) => {
  let errors = {};

  if (!(formState.userGroup?.length > 0)) {
    errors.userGroup = 'At least one User Group is required';
  }

  if (formState.orgUnitId.length > 0 && formState.useRenewalFee === undefined) {
    errors.useRenewalFee = 'Please select a Use Renewal Fee option';  
  }

  if (formState.useRenewalFee !== undefined && formState.orgUnitId.length === 0) {
    errors.orgUnitId = 'If a Use Renew Fee option is selected you must also select a Reuse Club';
  }

  return errors;
};

const UserGroupAddFormValidation = async (formState) => {
  let errors = localValidate(formState);

  return errors ? errors : {};
};

export default UserGroupAddFormValidation;